import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { IonicModule, ModalController, NavParams } from '@ionic/angular';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@Component({
  selector: 'app-pdffaktura',
  templateUrl: './pdffaktura.page.html',
  styleUrls: ['./pdffaktura.page.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, PdfViewerModule]
})
export class PdffakturaPage implements OnInit {
  safeResourceUrl: SafeResourceUrl;
  pdfData: Blob;
  plainUrl: string;
  zoom: number;

  invoNo: string;

  constructor(
    private _modalController: ModalController,
    private navParams: NavParams,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.pdfData = this.navParams.get('pdfData');
    this.invoNo = this.navParams.get('invoNo');

    this.plainUrl = URL.createObjectURL(this.pdfData);
    this.safeResourceUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(
      this.plainUrl
    );
    this.zoom = 1.0;
  }

  closeModal() {
    this._modalController.dismiss();
  }

  download() {
    this.openLink(this.plainUrl);
  }

  private openLink(url: string) {
    const a = document.createElement('a');
    // Firefox requires the link to be in the body
    document.body.appendChild(a);
    a.style.display = 'none';
    a.href = url;
    a.download = 'faktura' + this.invoNo + '.pdf';
    a.click();
    // Remove the link when done
    document.body.removeChild(a);
  }

  async goZoom(howMuch: number) {
    if (howMuch < 0) {
      if (this.zoom >= 1.0) {
        this.zoom = this.zoom + howMuch;
      }
    } else {
      if (this.zoom < 5.0) {
        this.zoom = this.zoom + howMuch;
      }
    }
  }
}
